var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ConstantService = /** @class */ (function (_super) {
            __extends(ConstantService, _super);
            function ConstantService(injectedBreeze, $q) {
                return _super.call(this, injectedBreeze, $q) || this;
            }
            ConstantService.prototype.getAllConstantsForProcessConfiguration = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ConstantValues")
                    .where("processConfiguration_id", "==", id);
                return this.executeQuery(query);
            };
            ConstantService.prototype.createConstant = function () {
                return this.createNewEntity("ConstantValue");
            };
            ConstantService.prototype.getConstant = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ConstantValues")
                    .where("id", "==", id);
                return this.fetch(query);
                //TODO: this call I am guessing due to caching would every once in a while return a null constant here when one existed in the DB with the specified ID. 
                //TODO: when we have more time spend a minute to figure out why
                //return this.fetchById(id, "ConstantValue");
            };
            return ConstantService;
        }(services.DataService));
        services.ConstantService = ConstantService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ConstantService', ['breeze', '$q']);
